import { Grid, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import RadioGroup from '@/components/RadioGroup/RadioGroup';

import { BundleLockSettings } from '../EditBundle.types';

export const LockSettings = (lockSettings: BundleLockSettings) => {
  const {
    onChange,
    isLockRedeemableOnline,
    isLockVisibleOnline,
    isLockPrice,
    lockRedeemableOnline,
    lockVisibleOnline,
    showLockPriceSwitch,
  } = lockSettings;

  const [lockState, setLockState] = useState({
    price: isLockPrice,
    onlineRedemption: isLockRedeemableOnline,
    onlineVisibility: isLockVisibleOnline,
    redeemOnline: lockRedeemableOnline,
    visibleOnline: lockVisibleOnline,
  });

  const onChangeSettings = () => {
    const b = {
      isLockRedeemableOnline: lockState.onlineRedemption,
      isLockVisibleOnline: lockState.onlineVisibility,
      isLockPrice: lockState.price,
      lockRedeemableOnline: lockState.redeemOnline,
      lockVisibleOnline: lockState.visibleOnline,
    } as BundleLockSettings;
    onChange(b);
  };

  const onChangeRadioGroupRedeemOnline = (id: string) => {
    if (id === 'redeemOnline') {
      setLockState({ ...lockState, redeemOnline: true });
    }
    if (id === 'notOnline') {
      setLockState({ ...lockState, redeemOnline: false, onlineVisibility: true, visibleOnline: false });
    }
  };

  const onChangeRadioOnlineVisibility = (id: string) => {
    if (id === 'visible') {
      setLockState({
        ...lockState,
        onlineRedemption: true,
        redeemOnline: true,
        visibleOnline: true,
      });
    } else {
      setLockState({
        ...lockState,
        visibleOnline: false,
      });
    }
  };

  useEffect(() => {
    onChangeSettings();
  }, [lockState]);

  return (
    <div>
      <Typography
        sx={{
          fontFamily: 'Open Sans',
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: '2.25rem',
          lineHeight: '17px',
          paddingTop: 1,
        }}
      >
        Lock Settings
      </Typography>
      {showLockPriceSwitch && (
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ paddingTop: 1 }}>
          <Grid>
            <Switch
              color="error"
              title="switch"
              data-testid="switch-price"
              checked={lockState.price}
              sx={{
                marginLeft: -1,
              }}
              onClick={() => {
                const newValue = !lockState.price;
                setLockState({ ...lockState, price: newValue });
              }}
            />
          </Grid>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'Open Sans',
                paddingTop: 1,
                fontSize: ' 2rem',
              }}
            >
              Price
            </Typography>
          </Grid>
        </Grid>
      )}
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ paddingTop: 1 }}>
        <Grid>
          <Switch
            color="error"
            title="switch"
            data-testid="switch-redemption"
            checked={lockState.onlineRedemption}
            sx={{
              marginLeft: -1,
            }}
            onClick={() => {
              setLockState({ ...lockState, onlineRedemption: !lockState.onlineRedemption, redeemOnline: false });
            }}
          />
        </Grid>
        <Grid item>
          <Typography
            sx={{
              fontFamily: 'Open Sans',
              paddingTop: 1,
              fontSize: ' 2rem',
            }}
          >
            Online Redemption
          </Typography>
        </Grid>
      </Grid>
      {lockState.onlineRedemption && (
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ paddingTop: 1 }}>
          <Grid item sx={{ marginLeft: 6, marginTop: -2 }}>
            <RadioGroup
              label=""
              selected={lockState.redeemOnline ? 'redeemOnline' : 'notOnline'}
              options={[
                { label: 'Redeem online', id: 'redeemOnline' },
                { label: 'Not online', id: 'notOnline' },
              ]}
              onChange={(event) => onChangeRadioGroupRedeemOnline(event.target.id)}
            />
          </Grid>
        </Grid>
      )}

      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ paddingTop: 1 }}>
        <Grid>
          <Switch
            color="error"
            title="switch"
            data-testid="switch-visibility"
            checked={lockState.onlineVisibility}
            sx={{
              marginLeft: -1,
            }}
            onClick={() => {
              const switchStateOld = lockState.onlineVisibility;
              const switchStateNew = !lockState.onlineVisibility;
              if (switchStateOld) {
                onChangeRadioOnlineVisibility('');
                setLockState({ ...lockState, onlineVisibility: switchStateNew, visibleOnline: false });
              } else {
                setLockState({ ...lockState, onlineVisibility: switchStateNew });
              }
            }}
          />
        </Grid>
        <Grid item>
          <Typography
            sx={{
              fontFamily: 'Open Sans',
              paddingTop: 1,
              fontSize: ' 2rem',
            }}
          >
            Online Visibility
          </Typography>
        </Grid>
      </Grid>

      {lockState.onlineVisibility && (
        <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" sx={{ paddingTop: 1 }}>
          <Grid item sx={{ marginLeft: 6, marginTop: -2 }}>
            <RadioGroup
              label=""
              selected={lockState.visibleOnline ? 'visible' : 'invisible'}
              options={[
                { label: 'Visible', id: 'visible' },
                { label: 'Invisible', id: 'invisible' },
              ]}
              onChange={(event) => onChangeRadioOnlineVisibility(event.target.id)}
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};
